// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("public/img/dragdrop-transparent.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("public/img/magnifier.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph-bottom-panel {
  flex: 0 0 0;
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
}

.graph-bottom-panel .collapsible-bottom-bar__content {
  background: #f4f4f4;
}

.graph-bottom-panel__header {
  height: 47px;
}

.graph-bottom-panel__header .nav-tabs-custom {
  background: none;
}

.graph-bottom-panel__header .nav-tabs-custom .nav-tabs:not(.disable-style) {
  background: none !important;
}

.graph-bottom-panel__header .scrolling-tabs .sc-wrapper {
  height: 42px;
  padding-bottom: 0 !important;
}

.graph-bottom-panel__header .nav-tabs-custom .nav-tabs:not(.disable-style) li {
  margin-right: 5px;
}

.graph-bottom-panel__header .nav-tabs-custom .nav-tabs:not(.disable-style) li:last-of-type {
  margin-right: 0;
}

.graph-bottom-panel__header .nav-tabs-custom .nav-tabs:not(.disable-style) li:first-of-type {
  margin-left: 10px;
}

.graph-bottom-panel__header .nav-tabs-custom .nav-tabs:not(.disable-style) li:not(.active) a {
  background: #f4f4f4;
  border-color: #dadada #dadada #ddd !important;
}

.graph-bottom-panel__header .nav-tabs-custom .nav-tabs:not(.disable-style) li.active a {
  background: #fff;
  border-bottom-color: #fff !important;
  border-left: 1px solid #dadada !important;
  border-right: 1px solid #dadada !important;
}

.graph-bottom-panel__header .nav-tabs > li.active > a {
  border-left: 1px solid #dadada;
  border-right: 1px solid #dadada;
}

.graph-bottom-panel__header .scroller {
  pointer-events: auto;
  background: #fff;
  border-top: 1px solid #dadada;
  padding-top: 11px;
}

.graph-bottom-panel__header .scroller:not(.disabled):hover {
  padding-top: 12px !important;
}

.graph-bottom-panel__header .scroller-left {
  border-right: 1px solid #dadada;
}

.graph-bottom-panel__header .scroller-right {
  border-left: 1px solid #dadada;
}

.graph-collapsible-bottom-bar__select-table {
  height: 40px;
  box-shadow: inset 0 -2px 1px -1px #ddd;
}

.graph-collapsible-bottom-bar__select-table .scrolling-tabs .sc-wrapper {
  height: 40px;
  padding: 0 !important;
}

.graph-collapsible-bottom-bar__select-table .scrolling-tabs .scroller, .graph-collapsible-bottom-bar__select-table .scrolling-tabs .scroller:not(.disabled):hover {
  background: none;
  padding-top: 11px;
  padding-bottom: 8px;
}

.graph-collapsible-bottom-bar__select-table .nav-tabs-custom {
  background: none;
}

.graph-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) {
  background: none !important;
  border-bottom-color: #0000 !important;
}

.graph-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li {
  height: 40px;
  margin-right: 5px;
}

.graph-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li:last-of-type {
  margin-right: 0;
}

.graph-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li:hover .graph-collapsible-bottom-bar__tabs-item-border {
  cursor: default;
}

.graph-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li:not(.active):hover .graph-collapsible-bottom-bar__tabs-item-border {
  cursor: pointer;
  background: #ddd;
}

.graph-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li.active a {
  border-top: 0 !important;
  border-left: 1px solid #fff !important;
  border-right: 1px solid #fff !important;
  padding-top: 11px !important;
}

.graph-collapsible-bottom-bar__select-table .nav-tabs > li > a:hover {
  background: none !important;
  border-color: #fff !important;
}

.graph-collapsible-bottom-bar__drag {
  cursor: ns-resize;
  pointer-events: auto;
  z-index: 65100;
  height: 7px;
  position: absolute;
  top: 42px;
  left: 0;
  right: 0;
}

.graph-collapsible-bottom-bar__drag:after {
  content: "";
  background: none;
  height: 2px;
  margin-top: 3px;
  transition: background .3s;
  display: block;
}

.graph-collapsible-bottom-bar__drag:hover:after {
  background: var(--info);
}

.graph-collapsible-bottom-bar__tabs-item-border {
  cursor: pointer;
  height: 4px;
  list-style: 4px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.graph-collapsible-bottom-bar__tabs-item-border--active {
  background: #6c7e9d;
}

.graph-setup-tables__overlay-content {
  width: 90vw;
  height: 90vh;
}

.graph-collapsible-bottom-bar__header-separator {
  background: #ddd;
  width: 1px;
  height: 26px;
  margin-left: 15px;
  margin-right: 20px;
  display: inline-block;
}

.graph-button {
  fill: #323232;
  border: 0;
  border-radius: 0;
}

.graph-button:hover {
  background: none;
  box-shadow: none !important;
}

.graph-button.text-disabled:hover, .graph-button :disabled:hover {
  color: var(--text-disabled);
}

.graph-button:not(.text-disabled):not(disabled):hover {
  color: var(--text-primary);
}

.graph-button:not(.text-disabled):not(disabled):hover path {
  fill: var(--text-primary);
}

.graph-button:disabled {
  color: var(--text-disabled);
}

.graph-button:disabled path {
  fill: var(--text-disabled);
}

.graph-button--danger:not(.text-disabled):not(disabled):hover {
  color: var(--danger);
}

.graph-button--danger:not(.text-disabled):not(disabled):hover use {
  fill: var(--danger);
}

.graph-collapsible-bottom-bar__header-button-config {
  width: 90px;
}

.graph-collapsible-bottom-bar__header-button-edit-tables {
  width: auto;
}

.graph-setup-tables__selected-tables-wrapper {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 190px 115px;
  min-height: 130px;
}

.graph-setup-tables__selected-tables-drop {
  pointer-events: auto;
  border: 1px solid #fff;
}

.graph-setup-tables__selected-tables-drop--hover {
  background-color: #f5f5f580;
  border: 1px dashed #d6d4d5;
}

.graph-setup-tables__selected-tables-items {
  border: 1px solid #eaeaea;
}

.graph-setup-tables__selected-tables-item:hover {
  background: #0000000a;
}

.graph-setup-tables__search {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) 7px 10px no-repeat;
  padding-left: 25px;
}

.graph-setup-tables__tree-wrapper {
  box-shadow: inset 1px 0 1px -1px #eaeaea;
}

.graph-setup-tables__tree-list {
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

.graph-setup-tables__tree-item {
  border-radius: 4px;
  padding: 3px 0;
}

.graph-setup-tables__tree-item:hover {
  background-color: #f5f5f5;
}

.graph-setup-tables__tree-item-caret {
  vertical-align: baseline;
  width: 21px;
  padding-left: 4px;
  padding-right: 9px;
}

.graph-setup-tables__tree-item-folder {
  vertical-align: baseline;
  padding-right: 5px;
}

.graph-setup-tables__footer {
  background: #f4f4f4;
  border-top: 1px solid #d6d4d5;
}

.graph-setup-tables__search-results {
  border: 1px solid #eaeaea;
}

.graph-setup-tables__search-results-item:hover {
  background: #0000000a;
}

.graph__overlay-wrapper {
  transition: opacity .2s ease-in;
}

.graph__overlay-wrapper--hidden {
  opacity: 0;
  pointer-events: none;
}

.graph__overlay {
  background: var(--background-white-semi);
  z-index: 1;
  position: absolute;
  inset: 0;
}

.graph-window {
  height: 100%;
  min-height: 300px;
  box-shadow: var(--window-box-shadow);
  flex-direction: column;
  margin-bottom: 0;
  display: flex;
}

.graph-window .box-header .box-title {
  margin-right: 20px;
  margin-top: 0 !important;
}

.graph-window .box-body {
  cursor: default;
  background: #f4f4f4;
  flex-direction: column;
  flex: 1;
  display: flex;
  overflow-y: auto;
}

.graph-window .nav-tabs-custom, .graph-window .table-condensed {
  margin-bottom: 0;
}

.graph-options-window {
  box-shadow: var(--window-box-shadow);
  z-index: 9999;
  width: 80%;
  height: 80%;
  margin-bottom: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media (width >= 768px) {
  .graph-options-window {
    height: 50%;
  }
}

@media (width >= 1408px) {
  .graph-options-window {
    width: 70%;
  }
}

@media (width >= 1600px) {
  .graph-options-window {
    width: 60%;
  }
}

.graph-options-window .box-body {
  flex-direction: row;
  display: flex;
}

.graph-options-window .box-header .box-title {
  margin-top: 2px !important;
  margin-bottom: 2px !important;
}

.graph-draggable-item__preview {
  pointer-events: none;
  z-index: 1000;
  width: 395px;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
}

.graph-draggable-item__box-shadow {
  background: #fff;
  padding: 3px;
  box-shadow: 0 0 10px #ccc;
}

.graph-draggable-item__box-border {
  border: 1px dashed #ccc;
  position: relative;
}

.graph-tooltip {
  position: absolute;
}

.graph-tooltip__content {
  --tw-bg-opacity: 1;
  background-color: rgb(50 50 50 / var(--tw-bg-opacity));
  color: #fff;
  border-radius: 4px;
}

.graph-tooltip__arrow-bottom {
  border-top: 9px solid #323232;
  border-left: 9px solid #0000;
  border-right: 9px solid #0000;
  width: 0;
  height: 0;
}

.graph-tooltip__arrow-top {
  border-bottom: 9px solid #323232;
  border-left: 9px solid #0000;
  border-right: 9px solid #0000;
  width: 0;
  height: 0;
}

.graph-stpi-warning__icon {
  --tw-text-opacity: 1;
  color: rgb(14 159 110 / var(--tw-text-opacity));
  font-size: .875rem;
  line-height: 1.25rem;
}

.graph-edge-context-menu:empty {
  display: none;
}

.graph-top-controls {
  pointer-events: none;
  width: 100%;
  padding: 5px;
  position: absolute;
  top: 0;
  left: 0;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/Graph/styles.css","webpack://./services/frontend/app/components/Graph/styles.css"],"names":[],"mappings":"AADA;ECEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yDAA4D;EAC5D,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sEAA8D;EAC9D,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,UAAU;EACV,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,oCAAoC;EACpC,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;EAC7B,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;EAC7B,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;EAC/C,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT","sourcesContent":[".graph-bottom-panel {\n  left: 0;\n  bottom: 0;\n  right: 0;\n  position: relative;\n  flex: 0 0 0;\n}\n\n  .graph-bottom-panel .collapsible-bottom-bar__content {\n    background: #f4f4f4;\n  }\n\n.graph-bottom-panel__header {\n  height: 47px;\n}\n\n.graph-bottom-panel__header .nav-tabs-custom {\n    background: none;\n  }\n\n.graph-bottom-panel__header .nav-tabs-custom .nav-tabs:not(.disable-style) {\n    background: none !important;\n  }\n\n.graph-bottom-panel__header .scrolling-tabs .sc-wrapper {\n    padding-bottom: 0 !important;\n    height: 42px;\n  }\n\n.graph-bottom-panel__header .nav-tabs-custom .nav-tabs:not(.disable-style) li {\n    margin-right: 5px;\n  }\n\n.graph-bottom-panel__header .nav-tabs-custom .nav-tabs:not(.disable-style) li:last-of-type {\n      margin-right: 0;\n    }\n\n.graph-bottom-panel__header .nav-tabs-custom .nav-tabs:not(.disable-style) li:first-of-type {\n      margin-left: 10px;\n    }\n\n.graph-bottom-panel__header .nav-tabs-custom .nav-tabs:not(.disable-style) li:not(.active) a {\n      background: #f4f4f4;\n      border-color: #dadada #dadada #ddd !important;\n    }\n\n.graph-bottom-panel__header .nav-tabs-custom .nav-tabs:not(.disable-style) li.active a {\n      background: #fff;\n      border-left: 1px solid #dadada !important;\n      border-right: 1px solid #dadada !important;\n      border-bottom-color: #fff !important;\n    }\n\n.graph-bottom-panel__header .nav-tabs > li.active > a {\n    border-left: 1px solid #dadada;\n    border-right: 1px solid #dadada;\n  }\n\n.graph-bottom-panel__header .scroller {\n  pointer-events: auto;\n  background: #fff;\n  border-top: 1px solid #dadada;\n  padding-top: 11px;\n}\n\n.graph-bottom-panel__header .scroller:not(.disabled):hover {\n    padding-top: 12px !important;\n  }\n\n.graph-bottom-panel__header .scroller-left {\n  border-right: 1px solid #dadada;\n}\n\n.graph-bottom-panel__header .scroller-right {\n  border-left: 1px solid #dadada;\n}\n\n.graph-collapsible-bottom-bar__select-table {\n  height: 40px;\n  box-shadow: inset 0 -2px 1px -1px #ddd;\n}\n\n.graph-collapsible-bottom-bar__select-table .scrolling-tabs .sc-wrapper {\n    height: 40px;\n    padding: 0 !important;\n  }\n\n.graph-collapsible-bottom-bar__select-table .scrolling-tabs .scroller,\n  .graph-collapsible-bottom-bar__select-table .scrolling-tabs .scroller:not(.disabled):hover {\n    background: none;\n    padding-top: 11px;\n    padding-bottom: 8px;\n  }\n\n.graph-collapsible-bottom-bar__select-table .nav-tabs-custom {\n    background: none;\n  }\n\n.graph-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) {\n    background: none !important;\n    border-bottom-color: transparent !important;\n  }\n\n.graph-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li {\n    height: 40px;\n    margin-right: 5px;\n  }\n\n.graph-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li:last-of-type {\n      margin-right: 0;\n    }\n\n.graph-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li:hover .graph-collapsible-bottom-bar__tabs-item-border {\n      cursor: default;\n    }\n\n.graph-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li:not(.active):hover .graph-collapsible-bottom-bar__tabs-item-border {\n      background: #ddd;\n      cursor: pointer;\n    }\n\n.graph-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li.active a {\n    padding-top: 11px !important;\n    border-left: 1px solid #fff !important;\n    border-right: 1px solid #fff !important;\n    border-top: 0 !important;\n  }\n\n.graph-collapsible-bottom-bar__select-table .nav-tabs > li > a:hover {\n    background: none !important;\n    border-color: #fff !important;\n  }\n\n.graph-collapsible-bottom-bar__drag {\n  cursor: ns-resize;\n  height: 7px;\n  left: 0;\n  pointer-events: auto;\n  position: absolute;\n  right: 0;\n  top: 42px;\n  z-index: 65100;\n}\n\n.graph-collapsible-bottom-bar__drag:after {\n    display: block;\n    content: '';\n    margin-top: 3px;\n    height: 2px;\n    background: none;\n    transition: background 0.3s ease;\n  }\n\n.graph-collapsible-bottom-bar__drag:hover:after {\n    background: var(--info);\n  }\n\n.graph-collapsible-bottom-bar__tabs-item-border {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  bottom: 0;\n  cursor: pointer;\n  height: 4px;\n  left: 0;\n  list-style: 4px;\n  position: absolute;\n  right: 0;\n}\n\n.graph-collapsible-bottom-bar__tabs-item-border--active {\n  background: #6c7e9d;\n}\n\n.graph-setup-tables__overlay-content {\n  width: 90vw;\n  height: 90vh;\n}\n\n.graph-collapsible-bottom-bar__header-separator {\n  display: inline-block;\n  height: 26px;\n  margin-left: 15px;\n  margin-right: 20px;\n  width: 1px;\n  background: #ddd;\n}\n\n.graph-button {\n  border: 0;\n  border-radius: 0;\n  fill: #323232;\n}\n\n.graph-button:hover {\n    background: transparent;\n    box-shadow: none !important;\n  }\n\n.graph-button.text-disabled:hover,\n  .graph-button :disabled:hover {\n    color: var(--text-disabled);\n  }\n\n.graph-button:not(.text-disabled):not(disabled):hover {\n    color: var(--text-primary);\n  }\n\n.graph-button:not(.text-disabled):not(disabled):hover path {\n  fill: var(--text-primary);\n}\n\n.graph-button:disabled {\n    color: var(--text-disabled);\n  }\n\n.graph-button:disabled path {\n      fill: var(--text-disabled);\n    }\n\n.graph-button--danger:not(.text-disabled):not(disabled):hover {\n    color: var(--danger);\n  }\n\n.graph-button--danger:not(.text-disabled):not(disabled):hover use {\n  fill: var(--danger);\n}\n\n.graph-collapsible-bottom-bar__header-button-config {\n  width: 90px;\n}\n\n.graph-collapsible-bottom-bar__header-button-edit-tables {\n  width: auto;\n}\n\n.graph-setup-tables__selected-tables-wrapper {\n  background-image: url('public/img/dragdrop-transparent.png');\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: 190px 115px;\n  min-height: 130px;\n}\n\n.graph-setup-tables__selected-tables-drop {\n  border: 1px solid #fff;\n  pointer-events: auto;\n}\n\n.graph-setup-tables__selected-tables-drop--hover {\n  background-color: rgba(245, 245, 245, 0.5);\n  border: 1px dashed #d6d4d5;\n}\n\n.graph-setup-tables__selected-tables-items {\n  border: 1px solid #eaeaea;\n}\n\n.graph-setup-tables__selected-tables-item:hover {\n    background: rgba(0, 0, 0, 0.04);\n  }\n\n.graph-setup-tables__search {\n  background: url('public/img/magnifier.png') 7px 10px no-repeat;\n  padding-left: 25px;\n}\n\n.graph-setup-tables__tree-wrapper {\n  box-shadow: inset 1px 0 1px -1px #eaeaea;\n}\n\n.graph-setup-tables__tree-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n}\n\n.graph-setup-tables__tree-item {\n  border-radius: 4px;\n  padding: 3px 0;\n}\n\n.graph-setup-tables__tree-item:hover {\n    background-color: #f5f5f5;\n  }\n\n.graph-setup-tables__tree-item-caret {\n  padding-right: 9px;\n  padding-left: 4px;\n  vertical-align: baseline;\n  width: 21px;\n}\n\n.graph-setup-tables__tree-item-folder {\n  padding-right: 5px;\n  vertical-align: baseline;\n}\n\n.graph-setup-tables__footer {\n  background: #f4f4f4;\n  border-top: 1px solid #d6d4d5;\n}\n\n.graph-setup-tables__search-results {\n  border: 1px solid #eaeaea;\n}\n\n.graph-setup-tables__search-results-item:hover {\n    background: rgba(0, 0, 0, 0.04);\n  }\n\n.graph__overlay-wrapper {\n  transition: opacity 0.2s ease-in;\n}\n\n.graph__overlay-wrapper--hidden {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.graph__overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--background-white-semi);\n  z-index: 1;\n}\n\n.graph-window {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  margin-bottom: 0;\n  min-height: 300px;\n  box-shadow: var(--window-box-shadow);\n}\n\n.graph-window .box-header .box-title {\n      margin-right: 20px;\n      margin-top: 0 !important;\n    }\n\n.graph-window .box-body {\n    background: #f4f4f4;\n    cursor: default;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    overflow-y: auto;\n  }\n\n.graph-window .nav-tabs-custom {\n    margin-bottom: 0;\n  }\n\n.graph-window .table-condensed {\n    margin-bottom: 0;\n  }\n\n.graph-options-window {\n  box-shadow: var(--window-box-shadow);\n  height: 80%;\n  left: 50%;\n  margin-bottom: 0;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 80%;\n  z-index: 9999;\n}\n\n@media (min-width: 768px) {\n\n.graph-options-window {\n    height: 50%\n}\n  }\n\n@media (min-width: 1408px) {\n\n.graph-options-window {\n    width: 70%\n}\n  }\n\n@media (min-width: 1600px) {\n\n.graph-options-window {\n    width: 60%\n}\n  }\n\n.graph-options-window .box-body {\n    display: flex;\n    flex-direction: row;\n  }\n\n.graph-options-window .box-header .box-title {\n    margin-top: 2px !important;\n    margin-bottom: 2px !important;\n  }\n\n.graph-draggable-item__preview {\n  height: 100%;\n  left: 0;\n  pointer-events: none;\n  position: fixed;\n  top: 0;\n  width: 395px;\n  z-index: 1000;\n}\n\n.graph-draggable-item__box-shadow {\n  background: #fff;\n  box-shadow: 0 0 10px #ccc;\n  padding: 3px;\n}\n\n.graph-draggable-item__box-border {\n  border: 1px dashed #ccc;\n  position: relative;\n}\n\n.graph-tooltip {\n  position: absolute;\n}\n\n.graph-tooltip__content {\n  --tw-bg-opacity: 1;\n  background-color: rgb(50 50 50 / var(--tw-bg-opacity));\n\n  border-radius: 4px;\n  color: #fff;\n}\n\n.graph-tooltip__arrow-bottom {\n  border-left: 9px solid transparent;\n  border-right: 9px solid transparent;\n  border-top: 9px solid #323232;\n  height: 0;\n  width: 0;\n}\n\n.graph-tooltip__arrow-top {\n  border-bottom: 9px solid #323232;\n  border-left: 9px solid transparent;\n  border-right: 9px solid transparent;\n  height: 0;\n  width: 0;\n}\n\n.graph-stpi-warning__icon {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  --tw-text-opacity: 1;\n  color: rgb(14 159 110 / var(--tw-text-opacity));\n}\n\n.graph-edge-context-menu:empty {\n  display: none;\n}\n\n.graph-top-controls {\n  position: absolute;\n  /* Actual elements inside graph-top-controls should set pointer-events:auto back, */\n  /* but the container must disable them to make the graph clickable behind */\n  /* the transparent part of this element. */\n  pointer-events: none;\n  top: 0;\n  left: 0;\n  width: 100%;\n  padding: 5px;\n}\n",".graph-bottom-panel {\n  flex: 0 0 0;\n  position: relative;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.graph-bottom-panel .collapsible-bottom-bar__content {\n  background: #f4f4f4;\n}\n\n.graph-bottom-panel__header {\n  height: 47px;\n}\n\n.graph-bottom-panel__header .nav-tabs-custom {\n  background: none;\n}\n\n.graph-bottom-panel__header .nav-tabs-custom .nav-tabs:not(.disable-style) {\n  background: none !important;\n}\n\n.graph-bottom-panel__header .scrolling-tabs .sc-wrapper {\n  height: 42px;\n  padding-bottom: 0 !important;\n}\n\n.graph-bottom-panel__header .nav-tabs-custom .nav-tabs:not(.disable-style) li {\n  margin-right: 5px;\n}\n\n.graph-bottom-panel__header .nav-tabs-custom .nav-tabs:not(.disable-style) li:last-of-type {\n  margin-right: 0;\n}\n\n.graph-bottom-panel__header .nav-tabs-custom .nav-tabs:not(.disable-style) li:first-of-type {\n  margin-left: 10px;\n}\n\n.graph-bottom-panel__header .nav-tabs-custom .nav-tabs:not(.disable-style) li:not(.active) a {\n  background: #f4f4f4;\n  border-color: #dadada #dadada #ddd !important;\n}\n\n.graph-bottom-panel__header .nav-tabs-custom .nav-tabs:not(.disable-style) li.active a {\n  background: #fff;\n  border-bottom-color: #fff !important;\n  border-left: 1px solid #dadada !important;\n  border-right: 1px solid #dadada !important;\n}\n\n.graph-bottom-panel__header .nav-tabs > li.active > a {\n  border-left: 1px solid #dadada;\n  border-right: 1px solid #dadada;\n}\n\n.graph-bottom-panel__header .scroller {\n  pointer-events: auto;\n  background: #fff;\n  border-top: 1px solid #dadada;\n  padding-top: 11px;\n}\n\n.graph-bottom-panel__header .scroller:not(.disabled):hover {\n  padding-top: 12px !important;\n}\n\n.graph-bottom-panel__header .scroller-left {\n  border-right: 1px solid #dadada;\n}\n\n.graph-bottom-panel__header .scroller-right {\n  border-left: 1px solid #dadada;\n}\n\n.graph-collapsible-bottom-bar__select-table {\n  height: 40px;\n  box-shadow: inset 0 -2px 1px -1px #ddd;\n}\n\n.graph-collapsible-bottom-bar__select-table .scrolling-tabs .sc-wrapper {\n  height: 40px;\n  padding: 0 !important;\n}\n\n.graph-collapsible-bottom-bar__select-table .scrolling-tabs .scroller, .graph-collapsible-bottom-bar__select-table .scrolling-tabs .scroller:not(.disabled):hover {\n  background: none;\n  padding-top: 11px;\n  padding-bottom: 8px;\n}\n\n.graph-collapsible-bottom-bar__select-table .nav-tabs-custom {\n  background: none;\n}\n\n.graph-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) {\n  background: none !important;\n  border-bottom-color: #0000 !important;\n}\n\n.graph-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li {\n  height: 40px;\n  margin-right: 5px;\n}\n\n.graph-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li:last-of-type {\n  margin-right: 0;\n}\n\n.graph-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li:hover .graph-collapsible-bottom-bar__tabs-item-border {\n  cursor: default;\n}\n\n.graph-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li:not(.active):hover .graph-collapsible-bottom-bar__tabs-item-border {\n  cursor: pointer;\n  background: #ddd;\n}\n\n.graph-collapsible-bottom-bar__select-table .nav-tabs-custom .nav-tabs:not(.disable-style) li.active a {\n  border-top: 0 !important;\n  border-left: 1px solid #fff !important;\n  border-right: 1px solid #fff !important;\n  padding-top: 11px !important;\n}\n\n.graph-collapsible-bottom-bar__select-table .nav-tabs > li > a:hover {\n  background: none !important;\n  border-color: #fff !important;\n}\n\n.graph-collapsible-bottom-bar__drag {\n  cursor: ns-resize;\n  pointer-events: auto;\n  z-index: 65100;\n  height: 7px;\n  position: absolute;\n  top: 42px;\n  left: 0;\n  right: 0;\n}\n\n.graph-collapsible-bottom-bar__drag:after {\n  content: \"\";\n  background: none;\n  height: 2px;\n  margin-top: 3px;\n  transition: background .3s;\n  display: block;\n}\n\n.graph-collapsible-bottom-bar__drag:hover:after {\n  background: var(--info);\n}\n\n.graph-collapsible-bottom-bar__tabs-item-border {\n  cursor: pointer;\n  height: 4px;\n  list-style: 4px;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.graph-collapsible-bottom-bar__tabs-item-border--active {\n  background: #6c7e9d;\n}\n\n.graph-setup-tables__overlay-content {\n  width: 90vw;\n  height: 90vh;\n}\n\n.graph-collapsible-bottom-bar__header-separator {\n  background: #ddd;\n  width: 1px;\n  height: 26px;\n  margin-left: 15px;\n  margin-right: 20px;\n  display: inline-block;\n}\n\n.graph-button {\n  fill: #323232;\n  border: 0;\n  border-radius: 0;\n}\n\n.graph-button:hover {\n  background: none;\n  box-shadow: none !important;\n}\n\n.graph-button.text-disabled:hover, .graph-button :disabled:hover {\n  color: var(--text-disabled);\n}\n\n.graph-button:not(.text-disabled):not(disabled):hover {\n  color: var(--text-primary);\n}\n\n.graph-button:not(.text-disabled):not(disabled):hover path {\n  fill: var(--text-primary);\n}\n\n.graph-button:disabled {\n  color: var(--text-disabled);\n}\n\n.graph-button:disabled path {\n  fill: var(--text-disabled);\n}\n\n.graph-button--danger:not(.text-disabled):not(disabled):hover {\n  color: var(--danger);\n}\n\n.graph-button--danger:not(.text-disabled):not(disabled):hover use {\n  fill: var(--danger);\n}\n\n.graph-collapsible-bottom-bar__header-button-config {\n  width: 90px;\n}\n\n.graph-collapsible-bottom-bar__header-button-edit-tables {\n  width: auto;\n}\n\n.graph-setup-tables__selected-tables-wrapper {\n  background-image: url(\"public/img/dragdrop-transparent.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 190px 115px;\n  min-height: 130px;\n}\n\n.graph-setup-tables__selected-tables-drop {\n  pointer-events: auto;\n  border: 1px solid #fff;\n}\n\n.graph-setup-tables__selected-tables-drop--hover {\n  background-color: #f5f5f580;\n  border: 1px dashed #d6d4d5;\n}\n\n.graph-setup-tables__selected-tables-items {\n  border: 1px solid #eaeaea;\n}\n\n.graph-setup-tables__selected-tables-item:hover {\n  background: #0000000a;\n}\n\n.graph-setup-tables__search {\n  background: url(\"public/img/magnifier.png\") 7px 10px no-repeat;\n  padding-left: 25px;\n}\n\n.graph-setup-tables__tree-wrapper {\n  box-shadow: inset 1px 0 1px -1px #eaeaea;\n}\n\n.graph-setup-tables__tree-list {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.graph-setup-tables__tree-item {\n  border-radius: 4px;\n  padding: 3px 0;\n}\n\n.graph-setup-tables__tree-item:hover {\n  background-color: #f5f5f5;\n}\n\n.graph-setup-tables__tree-item-caret {\n  vertical-align: baseline;\n  width: 21px;\n  padding-left: 4px;\n  padding-right: 9px;\n}\n\n.graph-setup-tables__tree-item-folder {\n  vertical-align: baseline;\n  padding-right: 5px;\n}\n\n.graph-setup-tables__footer {\n  background: #f4f4f4;\n  border-top: 1px solid #d6d4d5;\n}\n\n.graph-setup-tables__search-results {\n  border: 1px solid #eaeaea;\n}\n\n.graph-setup-tables__search-results-item:hover {\n  background: #0000000a;\n}\n\n.graph__overlay-wrapper {\n  transition: opacity .2s ease-in;\n}\n\n.graph__overlay-wrapper--hidden {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.graph__overlay {\n  background: var(--background-white-semi);\n  z-index: 1;\n  position: absolute;\n  inset: 0;\n}\n\n.graph-window {\n  height: 100%;\n  min-height: 300px;\n  box-shadow: var(--window-box-shadow);\n  flex-direction: column;\n  margin-bottom: 0;\n  display: flex;\n}\n\n.graph-window .box-header .box-title {\n  margin-right: 20px;\n  margin-top: 0 !important;\n}\n\n.graph-window .box-body {\n  cursor: default;\n  background: #f4f4f4;\n  flex-direction: column;\n  flex: 1;\n  display: flex;\n  overflow-y: auto;\n}\n\n.graph-window .nav-tabs-custom, .graph-window .table-condensed {\n  margin-bottom: 0;\n}\n\n.graph-options-window {\n  box-shadow: var(--window-box-shadow);\n  z-index: 9999;\n  width: 80%;\n  height: 80%;\n  margin-bottom: 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n@media (width >= 768px) {\n  .graph-options-window {\n    height: 50%;\n  }\n}\n\n@media (width >= 1408px) {\n  .graph-options-window {\n    width: 70%;\n  }\n}\n\n@media (width >= 1600px) {\n  .graph-options-window {\n    width: 60%;\n  }\n}\n\n.graph-options-window .box-body {\n  flex-direction: row;\n  display: flex;\n}\n\n.graph-options-window .box-header .box-title {\n  margin-top: 2px !important;\n  margin-bottom: 2px !important;\n}\n\n.graph-draggable-item__preview {\n  pointer-events: none;\n  z-index: 1000;\n  width: 395px;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n\n.graph-draggable-item__box-shadow {\n  background: #fff;\n  padding: 3px;\n  box-shadow: 0 0 10px #ccc;\n}\n\n.graph-draggable-item__box-border {\n  border: 1px dashed #ccc;\n  position: relative;\n}\n\n.graph-tooltip {\n  position: absolute;\n}\n\n.graph-tooltip__content {\n  --tw-bg-opacity: 1;\n  background-color: rgb(50 50 50 / var(--tw-bg-opacity));\n  color: #fff;\n  border-radius: 4px;\n}\n\n.graph-tooltip__arrow-bottom {\n  border-top: 9px solid #323232;\n  border-left: 9px solid #0000;\n  border-right: 9px solid #0000;\n  width: 0;\n  height: 0;\n}\n\n.graph-tooltip__arrow-top {\n  border-bottom: 9px solid #323232;\n  border-left: 9px solid #0000;\n  border-right: 9px solid #0000;\n  width: 0;\n  height: 0;\n}\n\n.graph-stpi-warning__icon {\n  --tw-text-opacity: 1;\n  color: rgb(14 159 110 / var(--tw-text-opacity));\n  font-size: .875rem;\n  line-height: 1.25rem;\n}\n\n.graph-edge-context-menu:empty {\n  display: none;\n}\n\n.graph-top-controls {\n  pointer-events: none;\n  width: 100%;\n  padding: 5px;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
